// extracted by mini-css-extract-plugin
module.exports = {"librarySearchSection":"LibrarySearch_librarySearchSection__CYpR8","search":"LibrarySearch_search__ap9Nr"};